const inspectionSystem = {
  Vesselparticulars: 1,
  InspectionSummary: 2,
  SummaryShort: 3,
  SummaryDetailed: 4,
  OperationalData: 5,
  OperationalDataCondition: 6,
  MainEngineFuelConsumption: 7,
  AuxiliaryEngineFuelConsumption: 8,
  LubeOilConsumption: 9,
  ClassSurveys: 10,
  Survey: 11,
  keyNotableItems: 0,
  GradingData: 15,
  // VesselCondition: 14,
  // VesselManagement: 15,
  DesignAndConstruction: 16,
  DesignandConstructionCondition: 17,
  HullAndStructure: 18,
  BridgeAndCommunication: 19,
  EngineRoomAndFirefighting: 20,
  Hull: 21,
  HullCondition: 22,
  FocscleAndPoopDeck: 23,
  MooringDecksCondition: 24,
  MainDeckAndFittings: 25,
  MainDeckAndFittingsCondition: 26,
  BallastTanksAndVoidSpaces: 27,
  BallastTanksAndSystemcondition: 28,
  GalleyAndAccommodation: 29,
  InternalAccommodationCondition: 30,
  GalleyCondition: 31,
  ExternalAreasCondition: 32,
  NavigationBridgeAndCommunication: 33,
  GeneralCondition: 34,
  NavigationCondition: 35,
  CommunicationCondition: 36,
  DocumentationCondition: 37,
  ExternalCondition: 38,
  EngineRoomMachineryAndMachinerySpaces: 39,
  GeneralConditionER: 40,
  MainEngineCondition: 41,
  MainEngineSpecification: 42,
  MainEngineMaintenance: 43,
  Propulsion: 44,
  PowerGeneration: 45,
  AuxiliaryEnginesMaintenance: 46,
  AuxiliaryMachinery: 47,
  Equipment: 48,
  ECRAndElectrical: 49,
  FireAndSafetyAppliances: 50,
  FireAndSafetyAppliancesCondition: 51,
  LifeSavingEquipment: 52,
  LifesavingAppliancesCondition: 53,
  SafeWorking: 54,
  SafeWorkingCondition: 55,
  PollutionControl: 56,
  GeneralConditionPC: 57,
  OilMARPOLAnnexI: 58,
  SewageMARPOLAnnexII: 59,
  GarbageMARPOLAnnexV: 60,
  AirMARPOLAnnexVI: 61,
  OnboardManagementAndCrewWelfare: 62,
  OnboardManagementCondition: 63,
  DecarbanizationSummary:93,
  DecarbanizationSummaryCondition:92,
  CargoSystems: 64,
  NotesToTheReader: 65,
  //container sections  
  CargoCondition: 66,
  CargoHoldCapacities: 67,
  Reefercapacity: 69,
  CargoSystemsCondition: 70,
  LiftingAppliancesCondition: 72,
  ClosingAppliancesCondition: 74,
  CargoSecuringCondition: 76,
  //Bulker
  VesselCapabilitiesandCargoSystemBulk: 77,
  HatchCoversCondition: 79,
  HatchCoamingsCondition: 80,
  DocumentationandAdditionalFeatures: 81,
  CargoLiftingAppliancesCondition: 82,
  //Tanker
  CargoTanks: 85,
  PumpingandPipingSystems: 86,
  CargoPumps: 87,
  MonitoringandSafetyArrangements: 88,
  Vetting: 89,
  ConcludingStatement: 90,
  NotestotheReader: 91,
  //Gas Carrier-LNG
  CargoTanksLNG: 95,
  PumpingandPipingSystemsLNG: 96,
  MonitoringandSafetyArrangementsLNG: 97,
  VettingLNG: 98,
  EquipmentLNG:99,
  //Gas Carrier-LPG
  CargoTanksLPG: 100,
  PumpingandPipingSystemsLPG: 101,
  MonitoringandSafetyArrangementsLPG: 102,
  VettingLPG: 103,
  EquipmentLPG:104,
};

export const VesselStatus = {
  Status: 1,
  InspectionType: 2,
  ShipType: 5,
  SubCategory: 6,
};

export const isUserRole = {
  Admin: 1,
  FieldInspector: 2,
  Client: 3,
  ExternalClient:4,
};

export const inspectionType = {
  PreSale: 5,
  PrePurchase: 6,
  VesselCondition: 7,
  PreDDCondition:72,
};

export const shipType = {
  Tanker: 8,
  Container: 9,
  Bulker: 10,
};

export const answerType = {
  multiplecheckbox : 63,
}

export { inspectionSystem };